import { render, staticRenderFns } from "./ModalBadgeLabel.vue?vue&type=template&id=79c3c2ce&scoped=true&"
import script from "./ModalBadgeLabel.vue?vue&type=script&lang=js&"
export * from "./ModalBadgeLabel.vue?vue&type=script&lang=js&"
import style0 from "./ModalBadgeLabel.vue?vue&type=style&index=0&id=79c3c2ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c3c2ce",
  null
  
)

export default component.exports